import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PsychosService } from "../../../api/services";
import { ResponsePsychoDto, UpdatePsychoDto } from "../../../api/models";
import { environment } from "../../../environments/environment";

const TENANT = environment.tenant;

@Injectable({
  providedIn: "root",
})
export class PsychologistsApiService {
  /** The psychos service from API */
  private readonly _psychosService: PsychosService = inject(PsychosService);

  /**
   * Get a random psychologist for a patient.
   * @param patientId the patient ID
   * @returns Observable with the random psychologist.
   */
  public getRandomPsychologist$(patientId: string): Observable<ResponsePsychoDto> {
    return this._psychosService.psychosControllerFindRandom({
      tenant: TENANT,
      patientId: patientId,
    });
  }

  /**
   * Find a psychologist by ID.
   * @param id the ID of the psychologist.
   * @returns observable with the psychologist data.
   */
  public findOne$(id: string): Observable<ResponsePsychoDto> {
    return this._psychosService.psychosControllerFindOne({
      tenant: TENANT,
      id,
    });
  }

  /**
   * Update a psychologist
   * @param id the psychologist ID
   * @param body the update data
   * @returns Observable with the updated psychologist
   */
  public update$(
    id: string,
    body: UpdatePsychoDto,
  ): Observable<ResponsePsychoDto> {
    return this._psychosService.psychosControllerUpdate({
      tenant: TENANT,
      id,
      body,
    });
  }
}
